import React from 'react'

function Newsletter() {
  return (
    <div>
        <div className="container-fluid position-relative pt-5 wow fadeInUp" data-wow-delay="0.1s" style={{ zIndex: 1 }}>
            <div className="container">
                <div className="bg-primary p-5">
                    <h2 style={{ textAlign: 'center', color: '#fff' }}>WELCOME TO SENATOR HOTEL</h2>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Newsletter